import { getInsFromPatient, remoteFormats } from "./index";

export const extractOpenDmp = (data) => {
  const {
          addAccessAuthorization: {
            value: addAccessAuthorization
          } = {},
          useBdgAccess: {
            value: useBdgAccess
          } = {},
          bdgAccessReason: {
            value: bdgAccessReason
          } = {}
        }   = data;
  const ins = getInsFromPatient(data, remoteFormats.XML);
  
  return {
    addAccessAuthorization: [true, "true", "1", 1].includes(addAccessAuthorization),
    useBdgAccess: [true, "true", "1", 1].includes(useBdgAccess),
    bdgAccessReason,
    ...ins
  };
};

export const extractJSONOpenDmp = (data) => {
  const {
          addAccessAuthorization, useBdgAccess, bdgAccessReason
        }   = data;
  const ins = getInsFromPatient(data, remoteFormats.JSON);
  
  return { addAccessAuthorization, useBdgAccess, bdgAccessReason, ...ins };
};